import {
	comMapping
} from '../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "suosq",
				label: '所属期',
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "input"
			},
			{
				prop: "daikdjpzbh",
				label: '代扣代缴凭证编号',
				type: "input"
			},
			{
				prop: "koujrmc",
				label: '扣缴人名称',
				type: "input"
			},
			{
				prop: "zhengsjgmc",
				label: '征收机关名称',
				type: "input"
			},
			{
				prop: "daikdjxm",
				label: '代扣代缴项目',
				type: "input"
			},
			{
				prop: "shuie",
				label: '税额',
				type: "inputplus"
			},
			{
				prop: "dikbz",
				label: '抵扣标志',
				type: "select",
				selectval: comMapping.$Dikbz
			}
		],
		searchdata: {
			companyCode: "",
			suosq: "",
			nsrsbh: "",
			daikdjpzbh: "",
			koujrmc: "",
			zhengsjgmc: "",
			daikdjxm: "",
			shuie: [],
			dikbz: ""
		},
		headData: [{
				title: "公司代码",
				prop: "companyCode",
				width: 80,
				custom: true,

			},
			{
				title: "所属期",
				prop: "suosq",
				width: 80,
				custom: true,

			},
			{
				title: "纳税人识别号",
				prop: "nsrsbh",
				width: 160,
				custom: true,

			},
			{
				title: "代扣代缴凭证编号",
				prop: "daikdjpzbh",
				width: 135,
				custom: true,

			},
			{
				title: "征收机关名称",
				prop: "zhengsjgmc",
				width: 125,
				custom: true,

			},
			{
				title: "扣缴人名称",
				prop: "koujrmc",
				width: 110,
				custom: true,

			},
			{
				title: "代扣代缴项目",
				prop: "daikdjxm",
				width: 110,
				custom: true,

			},
			{
				title: "税额",
				prop: "shuie",
				width: 80,
				AmountFormat: true,
				custom: true,

			},
			{
				title: "抵扣标志",
				prop: "dikbz",
				custom: true,
				width: 100
			},
			{
				title: "批次号",
				prop: "pich",
				width: 160,
				custom: true,
			}
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		syncForm: {
			issueDate: '',
			issueStart: '',
			issueEnd: ''
		},
	}
	return obj
}
